import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class GetKeysPipe implements PipeTransform {

  transform(object: any, args: string[]): any {
    const keys = [];
    if (!object) { return; }
    for (const key of Object.keys(object)) {
      keys.push(key);
    }
    return keys;
  }

}
